export default {
    deviceName: "Имя устройства",
    deviceSN: "Номер устройства",
    addedRobotDog: "Добавлена ​​новая собака-робот",
    editRobotDog: "Редактирование робота-собаки",
    online: "В сети",
    offline: "Не в сети",
    standingMode: "Режим ожидания",
    lockMode: "режим блокировки",
    enterMonitoring: "Войти в мониторинг",
    bindingCode: "Обязательный код",
    name: "имя",
    lockedState: "заблокированный статус",
    unlockedState: "Разблокированный статус",
    endStreaming: "Завершить трансляцию",
    startStreaming: "Начать трансляцию",
    emergencyStop: "экстренная остановка",
    lookUp: "искать",
    rotateLeft: "Поверните влево",
    bowYourHead: "склони голову",
    rotateRight: "Повернуть вправо",
    goAhead: "вперед, продолжать",
    shiftLeft: "Сдвиг влево",
    back: "Назад",
    shiftRight: "Двигаться вправо",
    pointCloudModeling: "Моделирование облака точек",
    stopModeling: "Хватит моделировать",
    startModeling: "Начать моделирование",
    pointCloudDownload: "Загрузка облака точек",
    stopCopying: "Хватит копировать",
    startCopying: "Начать копирование",
    returnToRobotDogList: "Вернуться к списку собак-роботов",
    getDown: "Спускайся",
    stand: "стоять",
    mobileMode: "мобильный режим",
    inPlaceMode: "Режим «на месте»",
    bodyElevation: "высота тела",
    turnLeft: "Поверните налево",
    bodyLowered: "тело опущено",
    turnRight: "Поверните направо",
    leftLeaning: "Левый наклон",
    rightLeaning: "наклоняясь вправо",
    tip_PETDN: "Пожалуйста, введите имя устройства",
    tip_PETDS: "Пожалуйста, введите серийный номер устройства",
    tip_PETRDS: "Пожалуйста, введите серийный номер собаки-робота",
    tip_PETBC: "Пожалуйста, введите код привязки",
    tip_PETNO: "Пожалуйста, введите имя собаки-робота",
    tip_TRDIC: "Собака-робот в настоящее время заблокирована. Нажмите, чтобы разблокировать.",
    tip_TRDICU: "Собака-робот в настоящее время разблокирована. Нажмите, чтобы заблокировать ее.",
    tip1: "Создается модель облака точек. Переместите собаку-робота.",
    tip2: "Пожалуйста, вставьте USB-диск в собаку-робота.",
    tip3: "Текущая собака-робот лежит. Нажмите, чтобы встать.",
    tip4: "Робот-собака в настоящее время стоит. Нажмите, чтобы лечь.",
    tip5: "Текущая собака-робот находится в мобильном режиме. Нажмите, чтобы переключиться в локальный режим.",
    tip6: "Текущая собака-робот находится в режиме на месте. Нажмите, чтобы переключиться в мобильный режим.",
};
